import React from 'react';

import { ExpLabel } from '@exp/components/localization';

import './AffiliationTeasers.less';

const AffilationTeasers = () => (
  <div className="aff-teasers">
    <ExpLabel
      className="aff-teasers-title"
      defaultMessage="How to score expert-only deals"
      messageKey="onb.affTeasers.title"
      tagName="h2"
    />
    <ul>
      <li className="aff-teasers-bullet">
        <i className="exp-ux-small exp-ux-cart" />
        <ExpLabel
          className="aff-teasers-bullet"
          defaultMessage="Add to cart on ExpertVoice to get your expert discounts instantly"
          messageKey="onb.affTeasers.bullet1"
          tagName="p"
        />
      </li>
      <li className="aff-teasers-bullet">
        <i className="exp-ux-small exp-ux-link" />
        <ExpLabel
          className="aff-teasers-bullet"
          defaultMessage="Access some expert discounts on brand sites via ExpertVoice"
          messageKey="onb.affTeasers.bullet2"
          tagName="p"
        />
      </li>
      <li className="aff-teasers-bullet">
        <i className="exp-ux-small exp-ux-graduationCap" />
        <ExpLabel
          className="aff-teasers-bullet"
          defaultMessage="Pass quick quizzes to activate your expert discounts on select deals"
          messageKey="onb.affTeasers.bullet3"
          tagName="p"
        />
      </li>
    </ul>
  </div>
);

AffilationTeasers.displayName = 'AffilationTeasers';

export default AffilationTeasers;
